<div class="card-basic">
  <div class="card-basic-body">
    <div class="text-center">
      <img ngSrc="assets/img/ikp-no-content-box.svg" alt="No content" class="no-content-icon" width="116" height="114" />
      <h3 class="no-content-title py-3">{{ cardTitle() | translate }}</h3>
    </div>
    <ng-content />
  </div>
</div>
